import { parseCalendarDate } from './date';

export function parseDates<T extends Record<string, any>>(obj: T, fields: string[]): T {
  const result = { ...obj } as Record<string, any>;
  for (const field of fields) {
    if (result[field] && typeof result[field] === 'string') {
      result[field] = parseCalendarDate(result[field]);
    }
  }

  return result as T;
}
